export { default } from "./CardTooltip";
